var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoba(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 591 801",
    style: {
      enableBackground: "new 0 0 591 801"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#CBFF00;}\r\n\t.st1{fill:#1CD7D1;}\r\n\t.st2{fill:#343434;}\r\n\t.st3{fill:#8C8C8C;}\r\n\t.st4{fill:#3C3C3B;}\r\n\t.st5{fill:#141414;}\r\n\t.st6{fill:#393939;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M114.1,555.7c-14.7,0-27.2-10.5-29.7-25.1L0.4,37.2c-1.3-7.9,0.5-15.9,5.1-22.5S17.1,3.8,25.1,2.5 c16.4-2.7,32,8.3,34.8,24.7l83.9,493.4c1.3,7.9-0.5,15.9-5.1,22.5c-4.7,6.6-11.6,10.9-19.5,12.3 C117.5,555.6,115.8,555.7,114.1,555.7z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M254.7,328.2c-48,0-92.6,14.4-129.9,39l10.2,59.7c32.1-27.9,74-44.9,119.7-44.9 c100.7,0,182.6,81.9,182.6,182.6s-81.9,182.6-182.6,182.6c-100.7,0-182.6-81.9-182.6-182.6c0-13.4,1.5-26.5,4.3-39.1l-16.2-95.1 c-26.4,38.1-41.9,84.4-41.9,134.2C18.3,694.9,124.3,801,254.7,801c130.4,0,236.4-106.1,236.4-236.4S385.1,328.2,254.7,328.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 241.8,
    cy: 670.3,
    r: 32.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 342.4,
    cy: 632.8,
    r: 32.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 263.3,
    cy: 563.8,
    r: 32.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 163.3,
    cy: 596.7,
    r: 32.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 362.9,
    cy: 530.8,
    r: 32.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 284.8,
    cy: 457.3,
    r: 32.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 183.9,
    cy: 494.7,
    r: 32.2
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "508.5,115.4 506.7,121.5 506.7,299.7 508.5,301.6 591.2,252.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "508.5,115.4 425.7,252.7 508.5,301.6 508.5,215  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "508.5,317.2 507.5,318.5 507.5,381.9 508.5,384.9 591.2,268.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "508.5,384.9 508.5,317.2 425.7,268.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "508.5,301.6 591.2,252.7 508.5,215  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "425.7,252.7 508.5,301.6 508.5,215  "
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoba);
export default __webpack_public_path__ + "static/media/boba.1e73cb23d7848512feb18b7ddc8ddf54.svg";
export { ForwardRef as ReactComponent };